module.exports = __webpack_public_path__ + "static/img/152_TO8_1868.b8c63f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/152_TO8_1868.jpg
// module id = lnLY
// module chunks = 0